import { Router } from "@angular/router";
import { Chart, registerables } from "chart.js";

export class ChartJsPieGraph {


    graph: any;

    constructor(private router: Router) {

    }

    draw(data: any[]){

        Chart.register(...registerables);
        let values = [];
        let labels = [];

        for(let i in data){
            values[i] = data[i].value;
            labels[i] = data[i].label;
        }

        this.graph = new Chart("pieGraph", {
            type: 'pie',
         
            data: {
                labels: labels,
                datasets: [{
                    label: "Energy Usage",
               
                    data: values,
                }],
            },
            options: {
                plugins: {
                    legend: {
                        display: false,
                    },
                    title: {
                        display: true,
                        text: 'Lightwave Device Usage',
                    },
                    
                },
                maintainAspectRatio: false,
                  onClick: (e) => {
                    let activePoints = this.graph.getElementsAtEventForMode(e, 'nearest', { intersect: true}, true);
                    if(!activePoints){
                        return;
                    }
                    let activePoint = activePoints[0];
                    
                    if(!activePoint){
                        return;
                    }

                    let element = data[activePoint.index];

                    if(!element){
                        return;
                    }
                    
                    if(!element.deviceType || !element.groupId){
                        return;
                    }

                    this.router.navigateByUrl("data-studio/detail/" + element.deviceType + "/" + element.groupId);
                }
            },
          
        });

        this.graph.canvas.parentNode.style.height = '400px';

    }


}